import { Component, OnInit, OnDestroy, ViewChildren, AfterViewInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';
import { ApiService } from 'src/app/core/services/api.service';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { Common } from 'src/app/core/constants/common';
import { LoginBase } from '../login/login-base';
import { TranslateService } from '@ngx-translate/core';
import {CommonService} from 'src/app/core/services/common.service';
import { Routes } from 'src/app/core/constants/routes';
import {HyperLink} from "../../core/constants/hyperlink";
import { MatDialog, MatDialogRef } from "@angular/material";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { DocumentService } from 'src/app/core/services/document.service';
import { NgForm, NgModel } from '@angular/forms';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})

/*
 * <pre>
 * <b>Class name: ForgotPasswordComponent</b>
 * <b>Explanation:</b> Component forgot password
 * <b>Creation date:</b> 2019/08/25
 * </pre>
 *
 * @author GCS 2019/07/01 by linhdh
 **/
export class ForgotPasswordComponent extends LoginBase implements OnInit, OnDestroy, AfterViewInit {
  error = '';
  subscription: Subscription;
  param: any;
  emailPattern = '^(\\b(84|0)([0-9]{9,10})\\b|[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,}))$';
  @Output() changeLanguage = new EventEmitter<boolean>();
  public phoneNumber: string = '';

  constructor(
    private router: Router,
    private authenSercvice: AuthenticationService,
    private apiService: ApiService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private message: Message,
    private toastr: ToastrService,
    private translate: TranslateService,
    public commonService: CommonService,
    private documentService: DocumentService,
    public dialog: MatDialog
  ) {
    super();
    this.phoneNumber = HyperLink.PHONE_NUMBER;
  }

  
  username:string = "";
  email:string = "";
  newPassword:string = "";
  confirmNewPassword:string = "";
  verifyCode:string = "";
  transactionId: string = "";
  currentLanguage = 'vi';
  notExistEmail: boolean;
  currentStep: number = 1;
  currentValidate: PasswordValidationResult = {
    hasLowercase: false,
    hasNumber: false,
    hasSpecialChar: false,
    hasUppercase: false,
    isValid: false,
    minLength: false
  };
  showNewPassword: boolean = false;
  showConfirmNewPassword: boolean = false;
  @ViewChildren("focusInput") focusInput;
  @ViewChild('errorDialog', { static: false }) errorDialog: any;
  @ViewChild('emailCtrl', { static: false }) emailCtrl1: NgModel;
  @ViewChild('newPasswordCtrl', { static: false }) newPasswordCtrl1: NgModel;
  @ViewChild('confirmNewPasswordCtrl', { static: false }) confirmNewPasswordCtrl1: NgModel;
  @ViewChild('verifyCodeCtrl', { static: false }) verifyCodeCtrl1: NgModel;
  @ViewChild('f3', { static: false }) form3: NgForm;
  @ViewChild('f2', { static: false }) form2: NgForm;
  errorMessage1: string = '';
  errorDialogRef: MatDialogRef<any> | null;
  resetTimeVerifyCode: number = 10;
  expireTimeVerifyCode: number = 300;
  intervalResetTime: any;
  intervalExpireTime: any;
  userPhone: any = "";
  userEmail: any = "";
  resetTimeVerifyCodeSystem: number = 10;
  expireTimeVerifyCodeSystem: number = 300;

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.param = params.get("id");
    });
    this.notificationService.subscribeErrorService();
    this.currentLanguage = localStorage.getItem('__language');
    if (!this.currentLanguage) {
      this.currentLanguage = 'vi';
    }
    this.documentService.getApparamInfo({code: "config_time_resend_otp"}).subscribe(res => {
      if(res.data && res.data.value){
        this.resetTimeVerifyCodeSystem = res.data.value;
        this.resetTimeVerifyCode = res.data.value;
      }
    })
    this.documentService.getApparamInfo({code: "otp_validity_period"}).subscribe(res => {
      if(res.data && res.data.value){
        this.expireTimeVerifyCodeSystem = res.data.value;
        this.expireTimeVerifyCode = res.data.value;
      }
    })
  }

  ngAfterViewInit() {
    setTimeout((_) => this.focusInput.first.nativeElement.focus());
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  /**
   * <pre>
   * <b>Method name: cancel</b>
   * <b>Explanation: </b> Method cancel reset password
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  cancel() {
    if (this.param == 1) {
      this.router.navigate(["enterprise-login"]);
    }
  }

  /**
   * <pre>
   * <b>Method name: resetPwd</b>
   * <b>Explanation: </b> Method reset password
   * </pre>
   * @author GCS 2019/09/03 by hungvo
   *
   */
  
  /**
   * Method name: onChangeLanguage
   */
  onChangeLanguage(languageSelected: string) {
    this.currentLanguage = languageSelected;
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }

  getCurrentNameLanguage(): string{ 
    switch(this.currentLanguage){
      case 'vi':
        return 'Tiếng Việt';
      case 'en':
        return 'English';
      case 'zh':
        return '中国人';
      case 'es':
        return 'Español';
      default:
        return 'Tiếng Việt'
    }
  }
  isOpen: boolean = false;

  confirmAccount(){
    if(this.username != ""){
      this.authenSercvice.checkUserName({username: this.username}).subscribe(res => {
        if(res.success){
          this.currentStep = 2;
          this.userPhone = res.data.phone || "";
          this.userEmail = res.data.email || "";
        } else {
          this.errorMessage1 = res.message;
          this.dialog.open(this.errorDialog, {
            width: "456px"
          });
        }
      })
      
    }
  }
  
  verificationCode(){
    if(this.email != "" && this.email.match(this.emailPattern)){
      this.authenSercvice.sendOtp({username: this.username, email: this.email}).subscribe(res => {
        if(res.success){
          this.currentStep = 3;
          this.transactionId = res.data;
          this.intervalResetTime = setInterval(()=>{
            if(this.resetTimeVerifyCode == 0){
              clearInterval(this.intervalResetTime);
            } else {
              this.resetTimeVerifyCode--;
            }
          },1000)
          this.intervalExpireTime = setInterval(()=>{
            if(this.expireTimeVerifyCode == 0){
              clearInterval(this.intervalExpireTime);
            } else {
              this.expireTimeVerifyCode--;
            }
          },1000)
          this.toastr.success(this.message.getMessage('login_page.reset_success'))
        } else {
          this.errorMessage1 = res.message;
          this.dialog.open(this.errorDialog, {
            width: "456px"
          });
        }
      })
    }
  }

  validatePassword(password: string): PasswordValidationResult {
    const minLength = password.length >= 8;
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[@#$%^&*+\-?.]/.test(password);
  
    const isValid = minLength && hasLowercase && hasUppercase && hasNumber && hasSpecialChar;
  
    return {
      isValid,
      minLength,
      hasLowercase,
      hasUppercase,
      hasNumber,
      hasSpecialChar
    };
  }

  validateNewPassWord(){
    this.currentValidate = this.validatePassword(this.newPassword)
  }

  resetOTP(){
    this.authenSercvice.sendOtp({username: this.username, email: this.email}).subscribe(res => {
      if(res.success){
        clearInterval(this.intervalResetTime);
        clearInterval(this.intervalExpireTime);
        this.transactionId = res.data;
        this.resetTimeVerifyCode = this.resetTimeVerifyCodeSystem;
        this.expireTimeVerifyCode = this.expireTimeVerifyCodeSystem;
        this.intervalResetTime = setInterval(()=>{
          if(this.resetTimeVerifyCode == 0){
            clearInterval(this.intervalResetTime);
          } else {
            this.resetTimeVerifyCode--;
          }
        },1000)
        this.intervalExpireTime = setInterval(()=>{
          if(this.expireTimeVerifyCode == 0){
            clearInterval(this.intervalExpireTime);
          } else {
            this.expireTimeVerifyCode--;
          }
        },1000)
        this.toastr.success(this.message.getMessage('login_page.reset_success'))
      } else {
        this.toastr.error(res.message)
      }
    })
  }

  changePassword(){
    if(!this.currentValidate.isValid){
      return;
    }
    const data = {
      username: this.username,
      otp: this.verifyCode,
      transactionId: this.transactionId,
      // tenantId: "emlkdm4vUGRxN0d1R0pmSjdFa29qQT09",
      newPassword: this.newPassword,
      confirmPassword: this.confirmNewPassword
    }
    this.authenSercvice.resetPasswordOtp(data).subscribe(res => {
      if(res.success){
        this.errorMessage1 = "";
        this.errorDialogRef = this.dialog.open(this.errorDialog, {
          width: "456px"
        });
        this.errorDialogRef.afterClosed().subscribe(res => {
          this.cancel()
        })
      } else {
        this.errorMessage1 = res.message;
        this.dialog.open(this.errorDialog, {
          width: "456px"
        });
      }
    })
  }

  nextStep(){
    if(this.currentStep === 1){
      this.confirmAccount()
    } else if(this.currentStep === 2) {
      this.verificationCode()
    } else if(this.currentStep === 3){
      this.changePassword()
    }
  }

  backStep(){
    if (this.currentStep == 2) {
      this.currentStep = 1;
      this.email = '';
      this.userEmail = '';
      this.userPhone = '';
      this.emailCtrl1.control.markAsUntouched();
      this.form2.resetForm()
    } else if(this.currentStep == 3) {
      this.currentStep = 2;
      this.verifyCode = '';
      this.newPassword = '';
      this.confirmNewPassword = '';
      this.newPasswordCtrl1.control.markAsUntouched();
      this.confirmNewPasswordCtrl1.control.markAsUntouched();
      this.verifyCodeCtrl1.control.markAsUntouched();
      clearInterval(this.intervalResetTime);
      clearInterval(this.intervalExpireTime);
      this.resetTimeVerifyCode = this.resetTimeVerifyCodeSystem;
      this.expireTimeVerifyCode = this.expireTimeVerifyCodeSystem;
      this.form3.resetForm()
    } else {
      return
    }
  }
  
  closeErrorDialog(){
    this.dialog.closeAll();
  }
}

export interface PasswordValidationResult {
  isValid: boolean;
  minLength: boolean;
  hasLowercase: boolean;
  hasUppercase: boolean;
  hasNumber: boolean;
  hasSpecialChar: boolean;
}